import axios from 'axios';
import store from './../store';
import router from "@/router";
import NotFoundPage from "@/views/pages/NotFoundPage";

let instance = axios.create({
    withCredentials: true
});

instance.interceptors.request.use(async request => {
    let user = JSON.parse(sessionStorage.getItem("user"));
    await store.dispatch('setIsLoading', true);
    request.headers.common['Accept'] = 'application/json';
    // request.headers.set('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE, OPTIONS');
    request.headers.common['Content-Type'] = ['application/json', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
    request.headers.common['Authorization'] = user ? 'Bearer ' + user.token : '';
    request.headers.common['Access-Control-Max-Age'] = '3000';
    // request.headers.common['Access-Control-Allow-Headers', 'X-Requested-With, Origin, X-Csrftoken, Content-Type, Accept'];
    return request;

});

instance.interceptors.response.use(
    async response => {
        await store.dispatch('setIsLoading', false);
        return response;
    },
    async error => {
        await store.dispatch('setIsLoading', false);
        if (error.response?.status === 401) {
            sessionStorage.removeItem('user');

            await router.push({
                path: "/error", name: "error", component: NotFoundPage, params: {
                    code: 401, message: "Unauthorized"
                }
            });
            await store.dispatch('setUser', null);
        } else if (error.response?.status === 404) {
            console.log(store.state.settings.activeTap);
            console.log(store.state.settings.currentRoute);
            await router.push('/' + store.state.settings.currentRoute);
        } else if (error.response?.status === 403) {
            console.log({error})
            await router.push({
                path: "/error", name: "error", component: NotFoundPage, params: {
                    code: 403, message: "Forbidden"
                }
            });

        } else if (error.response?.status === 500) {
            console.log({error})
            await router.push({
                path: "/error", name: "error", component: NotFoundPage, params: {
                    code: 500, message: "Server Error"
                }
            });

        }

        await store.dispatch('setErrorModal', true);
        await store.dispatch('setErrorMessage', error.response?.data.message);
        return Promise.reject(error);
    }
);


export default instance;